// extracted by mini-css-extract-plugin
export default {"popover-sla-status":"TicketDueDates_popover-sla-status__Ib-YP"};